// Atalhos de período (Hoje, 7 dias, 30 dias) + calendário para o recorte
// livre. Compartilhado entre o Dashboard e o Meu desempenho. Marcar a pílula
// ativa compara pelo MESMO formato que a URL guarda ("yyyy-MM-dd") — comparar
// Date por referência nunca casaria depois de um reload.
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import type { DateRange } from "react-day-picker";
import { Button } from "@/components/ui/button";
import { DateRangePicker } from "@/components/date-range-picker";
import "./i18n.js";

const PERIOD_PRESETS = [
  { key: "today", days: 0 },
  { key: "7d", days: 6 },
  { key: "30d", days: 29 },
] as const;

function isSamePreset(range: DateRange | undefined, days: number): boolean {
  if (!range?.from) return false;
  const preset = { from: subDays(new Date(), days), to: new Date() };
  const day = (date: Date) => format(date, "yyyy-MM-dd");
  return day(range.from) === day(preset.from) && day(range.to ?? range.from) === day(preset.to);
}

export function PeriodPills({
  range,
  onChange,
}: {
  range: DateRange | undefined;
  onChange: (range: DateRange | undefined) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center gap-1 rounded-full border border-border/60 bg-card p-1 shadow-surface">
        {PERIOD_PRESETS.map((preset) => {
          const active = isSamePreset(range, preset.days);
          return (
            <Button
              key={preset.key}
              type="button"
              size="sm"
              variant={active ? "default" : "ghost"}
              aria-pressed={active}
              className="h-8 rounded-full px-3.5 text-xs font-medium"
              onClick={() => onChange({ from: subDays(new Date(), preset.days), to: new Date() })}
            >
              {t(`dashboard.period.presets.${preset.key}`)}
            </Button>
          );
        })}
      </div>
      <DateRangePicker value={range} onChange={onChange} className="sm:w-auto" />
    </div>
  );
}
